export default __webpack_public_path__ + "images/YJ.27b6cba.png";